var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn-new-green btn-popup disabled-element",attrs:{"id":"request-offer-btn","href":"javascript:void(0)","data-popup":"request-offer-popup"}},[_vm._v(_vm._s(_vm.$t('requestOffer')))])
}
var staticRenderFns = []

export { render, staticRenderFns }